import * as ACTIONS from './actions';

const getDashboardData = data => ({
  benchmarks: data.benchmarks.map(a => a.benchmarkId),
  description: data.description,
  startDate: data.startDate,
  endDate: data.endDate,
  name: data.name,
  dateRangeTypeId: data.dateRangeTypeId
});

export const getInitialState = dashboardId => ({
  id: dashboardId,
  benchmarks: [],
  dateRangeTypeId: 0,
  description: '',
  startDate: null,
  endDate: null,
  name: null
});

export const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.SET_INITIAL_DASHBOARD_STATE:
      return {
        ...state,
        ...getDashboardData(payload)
      };
    case ACTIONS.SET_DASHBOARD_PROPERTY: {
      return {
        ...state,
        [payload.property]: payload.value
      };
    }
    default:
      return state;
  }
};
